<template>
   <button
      class="hamburger-menu-btn"
      :class="[{ 'text-brand-dark': mobileMenuIsShowing }, { 'text-black': !mobileMenuIsShowing }]"
      style="border-color: transparent"
      aria-haspopup="true"
      :aria-label="$t('system.toggle.menu')"
      :title="$t('system.toggle.menu')"
      :aria-expanded="`${props.mobileMenuIsShowing ? true : false}`"
      @click="emit('toggle-mobile-menu')"
   >
      <span class="relative w-8 h-8 hamburger-transition">
         <span class="hamburger-line" :class="{ 'hamburger-close': props.mobileMenuIsShowing }"></span>
         <span class="hamburger-line" :class="{ 'hamburger-close': props.mobileMenuIsShowing }"></span>
         <span class="hamburger-line" :class="{ 'hamburger-close': props.mobileMenuIsShowing }"></span>
      </span>
   </button>
</template>

<script setup lang="ts">
// props & emits
// -----------------------------------------
interface Props {
   mobileMenuIsShowing: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(["toggle-mobile-menu"]);
</script>

<style lang="scss" scoped>
.hamburger-menu-btn {
   color: var(--black);
   aspect-ratio: 1/1;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   border-radius: var(--size-base-6);
   width: var(--size-base-40);
   height: var(--size-base-40);
   &:hover {
      background-color: var(--grey-10);
   }
}

@media (min-width: 48rem) {
   .hamburger-menu-btn {
      visibility: hidden;
   }
}

.hamburger-transition {
   transition-property: background-color, color, border-color, opacity;
   transition-duration: 0.3s;
   transition-timing-function: ease-in-out;
}

.hamburger-line {
   @apply absolute rounded-full;
   height: 0.125rem;
   top: 0.625rem;
   left: 0.3125rem;
   right: 0.3125rem;
   background-color: currentColor;
   transition: transform 0.45s ease-in-out;

   &:nth-child(1) {
      transform-origin: left center;

      &.hamburger-close {
         transition-delay: 0.15s;
         transform: translate(15%, -200%) rotate(45deg);
      }
   }

   &:nth-child(2) {
      top: 0.9375rem;
      transition-duration: 0.45s;

      &.hamburger-close {
         transform: scaleX(0);
         transition: transform 0.3s ease-in-out;
      }
   }

   &:nth-child(3) {
      top: 1.3125rem;
      transform-origin: left center;

      &.hamburger-close {
         transition-delay: 0.15s;
         transform: translate(15%, 0%) rotate(-45deg);
      }
   }
}
</style>
